import { Avatar, AvatarFallback } from "@/components/ui/avatar";

type MessageAvatarProps = {
  isAssistant: boolean;
};

const MessageAvatar = ({ isAssistant }: MessageAvatarProps) => {
  return (
    <div className="flex-shrink-0">
      {isAssistant ? (
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500/30 to-purple-500/30 flex items-center justify-center shadow-lg border border-blue-500/20">
          <span className="font-inter font-bold text-sm text-blue-400">AX</span>
        </div>
      ) : (
        <Avatar className="h-8 w-8 border border-blue-500/20 shadow-md bg-gradient-to-br from-blue-700/30 to-blue-900/30 rounded-full">
          <AvatarFallback className="bg-transparent text-white font-semibold">
            <span className="font-inter font-bold text-xs text-blue-400">
              U
            </span>
          </AvatarFallback>
        </Avatar>
      )}
    </div>
  );
};

export default MessageAvatar;
